import { Pipe, PipeTransform } from '@angular/core';

import { PipeFunctions } from './_pipe.functions';
import { DateUtilsService } from '../common.component.module/date-utils.service';


@Pipe({
    name: 'pickYearOfDeDate',
    standalone: false
})
export class YearPickerPipe implements PipeTransform {

    transform(raw: string): string {
        return PipeFunctions.pickYearOfDeDate(raw);
    }

}

@Pipe({
    name: 'dateValue2DateInputPipe',
    standalone: false
})
export class DateValue2DateInputPipe implements PipeTransform {

    constructor(private dateUtilsService: DateUtilsService) {
    }

    transform(value: any): any {
        return this.dateUtilsService.convertReadableDate2InputDate(value);
    }

}

@Pipe({
    name: 'dateTimeArray2DateTimePipe',
    standalone: false
})
export class DateTimeArray2DateTimePipe implements PipeTransform {

    /**
     * Wandelt einen ISO-artigen Zeitstempel (z.B. "2026-05-13T10:37:38.333") in das
     * deutsche, lesbare Format "13.05.2026 10:37:38" um.
     */
    transform(input: string): string {
        if (!input) {
            return '';
        }

        // Datum und Uhrzeit anhand 'T' bzw. Leerzeichen trennen
        const [datePart, timePartRaw = ''] = input.split(/[T ]/);

        const [year, month, day] = datePart.split('-');
        // Millisekunden ggf. abschneiden
        const timePart = timePartRaw.split('.')[0];
        const [hours = '00', minutes = '00', seconds = '00'] = timePart.split(':');

        return `${day}.${month}.${year} um ${hours}:${minutes}:${seconds}`;
    }

}

@Pipe({
    name: 'dateInput2DateValuePipe',
    standalone: false
})
export class DateInput2DateValuePipe implements PipeTransform {

    transform(value: string): any {
        return value.substring(8, 10) + '.' + value.substring(5, 7) + '.' + value.substring(0, 4);
    }

}
